import validate from "/home/debian/projects/my-website/node_modules/.pnpm/nuxt@3.12.4_@parcel+watcher@2.4.1_@types+node@22.4.1_ioredis@5.4.1_magicast@0.3.4_rollup@4.21_qkclzdaycnzn77sttwwpnlbhz4/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/debian/projects/my-website/node_modules/.pnpm/nuxt@3.12.4_@parcel+watcher@2.4.1_@types+node@22.4.1_ioredis@5.4.1_magicast@0.3.4_rollup@4.21_qkclzdaycnzn77sttwwpnlbhz4/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}